(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Gallery = function () {
  function Gallery() {
    _classCallCheck(this, Gallery);

    // Do not run on pages where there is no gallery.
    if (document.querySelectorAll('.gallery').length === 0) return;

    // Load the gallery element.
    this.gallery = document.querySelector('.gallery');

    // Load the featured image element.
    this.featured = this.gallery.querySelector('.gallery--featured');

    // Load the gallery items.
    this.items = this.gallery.querySelectorAll('.gallery--item');

    // Load the caption.
    this.caption = this.gallery.querySelector('.gallery--caption');

    // Bind all mouse events.
    this.bindEvents();
  }

  // Binds the mouse events to each gallery item.


  _createClass(Gallery, [{
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      var _loop = function _loop(i, itemCount) {

        // Bind the update featured function to the on hover event.
        _this.items[i].onmouseover = function () {
          return _this.updateFeatured(_this.items[i]);
        };
      };

      // Cycle through all photos.
      for (var i = 0, itemCount = this.items.length; i < itemCount; i++) {
        _loop(i, itemCount);
      }
    }

    // Updates the featured image slot.

  }, {
    key: 'updateFeatured',
    value: function updateFeatured(new_item) {

      // Disable the old item.
      this.disableActiveItems();

      // Enable the new item.
      new_item.setAttribute('data-enabled', 'true');

      // Create an item object based on the given item.
      var item = {
        "source": new_item.getAttribute('data-source'),
        "alt": new_item.getAttribute('data-alt'),
        "caption": new_item.hasAttribute('data-caption') ? new_item.getAttribute('data-caption') : "null"
      };

      // Update the featured image.
      this.featured.setAttribute('alt', item.alt);
      this.featured.setAttribute('src', item.source);

      // Update the caption.
      if (item.caption !== "null") {
        this.caption.innerHTML = item.caption;
        this.caption.setAttribute('data-enabled', 'true');
      } else {
        this.caption.innerHTML = "";
        this.caption.setAttribute('data-enabled', 'false');
      }
    }

    // Disable the active item.

  }, {
    key: 'disableActiveItems',
    value: function disableActiveItems() {
      this.gallery.querySelector('.gallery--item[data-enabled="true"]').setAttribute('data-enabled', 'false');
    }
  }]);

  return Gallery;
}();

var gallery = exports.gallery = new Gallery();

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Nav = function () {
  function Nav() {
    var _this = this;

    _classCallCheck(this, Nav);

    // Load the nav.
    this.nav = document.querySelector('.nav');

    // Load the open button.
    this.openBtn = document.querySelector('.nav--open');

    // Load the close button.
    this.closeBtn = document.querySelector('.nav--close');

    // Bind the click events to the buttons.
    this.openBtn.onclick = function () {
      return _this.open();
    };
    this.closeBtn.onclick = function () {
      return _this.close();
    };
  }

  // Opens the nav.


  _createClass(Nav, [{
    key: 'open',
    value: function open() {
      this.nav.setAttribute('data-opened', 'true');
      this.closeBtn.setAttribute('data-active', 'true');
    }

    // Closes the nav.

  }, {
    key: 'close',
    value: function close() {
      this.closeBtn.setAttribute('data-active', 'false');
      this.nav.setAttribute('data-opened', 'false');
    }
  }]);

  return Nav;
}();

// Export the class.


var nav = exports.nav = new Nav();

},{}],3:[function(require,module,exports){
'use strict';

var _nav = require('../components/nav/nav');

var _nav2 = _interopRequireDefault(_nav);

var _gallery = require('../components/gallery/gallery');

var _gallery2 = _interopRequireDefault(_gallery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"../components/gallery/gallery":1,"../components/nav/nav":2}]},{},[3]);
